export const defaultWords = [
  // === EASY ===
  { word: "사과", language: "KOREAN" },
  { word: "바나나", language: "KOREAN" },
  { word: "하늘", language: "KOREAN" },
  { word: "구름", language: "KOREAN" },
  { word: "바다", language: "KOREAN" },
  { word: "나무", language: "KOREAN" },
  { word: "사람", language: "KOREAN" },
  { word: "아이", language: "KOREAN" },
  { word: "이름", language: "KOREAN" },
  { word: "우리", language: "KOREAN" },
  { word: "시간", language: "KOREAN" },
  { word: "오늘", language: "KOREAN" },
  { word: "내일", language: "KOREAN" },
  { word: "어제", language: "KOREAN" },
  { word: "아침", language: "KOREAN" },
  { word: "저녁", language: "KOREAN" },
  { word: "가을", language: "KOREAN" },
  { word: "겨울", language: "KOREAN" },
  { word: "여름", language: "KOREAN" },
  { word: "나라", language: "KOREAN" },
  { word: "도시", language: "KOREAN" },
  { word: "마을", language: "KOREAN" },
  { word: "가구", language: "KOREAN" },
  { word: "거리", language: "KOREAN" },
  { word: "다리", language: "KOREAN" },
  { word: "머리", language: "KOREAN" },
  { word: "허리", language: "KOREAN" },
  { word: "나이", language: "KOREAN" },
  { word: "고기", language: "KOREAN" },
  { word: "소리", language: "KOREAN" },
  { word: "노래", language: "KOREAN" },
  { word: "이야기", language: "KOREAN" },
  { word: "가게", language: "KOREAN" },
  { word: "가로", language: "KOREAN" },
  { word: "세로", language: "KOREAN" },
  { word: "무리", language: "KOREAN" },
  { word: "구리", language: "KOREAN" },
  { word: "비누", language: "KOREAN" },
  { word: "두부", language: "KOREAN" },
  { word: "소나무", language: "KOREAN" },
  { word: "바구니", language: "KOREAN" },
  { word: "거미", language: "KOREAN" },
  { word: "나비", language: "KOREAN" },
  { word: "토끼", language: "KOREAN" },
  { word: "오리", language: "KOREAN" },
  { word: "까치", language: "KOREAN" },
  { word: "비바람", language: "KOREAN" },
  { word: "구두", language: "KOREAN" },
  { word: "모자", language: "KOREAN" },
  { word: "우유", language: "KOREAN" },
  { word: "치마", language: "KOREAN" },
  { word: "바지", language: "KOREAN" },
  { word: "신발", language: "KOREAN" },
  { word: "가방", language: "KOREAN" },
  { word: "시계", language: "KOREAN" },
  { word: "거울", language: "KOREAN" },
  { word: "가위", language: "KOREAN" },
  { word: "버스", language: "KOREAN" },
  { word: "지하", language: "KOREAN" },
  { word: "도로", language: "KOREAN" },
  { word: "이마", language: "KOREAN" },
  { word: "어깨", language: "KOREAN" },
  { word: "무릎", language: "KOREAN" },
  { word: "눈썹", language: "KOREAN" },
  { word: "기차", language: "KOREAN" },
  { word: "자리", language: "KOREAN" },
  { word: "주머니", language: "KOREAN" },
  { word: "이불", language: "KOREAN" },
  { word: "베개", language: "KOREAN" },
  { word: "가루", language: "KOREAN" },
  { word: "소금", language: "KOREAN" },
  { word: "고추", language: "KOREAN" },
  { word: "마늘", language: "KOREAN" },
  { word: "파도", language: "KOREAN" },
  { word: "모래", language: "KOREAN" },
  { word: "아기", language: "KOREAN" },
  { word: "누나", language: "KOREAN" },
  { word: "오빠", language: "KOREAN" },
  { word: "여자", language: "KOREAN" },
  { word: "아버지", language: "KOREAN" },
  { word: "어머니", language: "KOREAN" },
  { word: "다음", language: "KOREAN" },
  { word: "시작", language: "KOREAN" },
  { word: "도장", language: "KOREAN" },
  { word: "비구름", language: "KOREAN" },
  { word: "바위", language: "KOREAN" },
  { word: "노을", language: "KOREAN" },
  { word: "이슬", language: "KOREAN" },
  { word: "아래", language: "KOREAN" },
  { word: "위로", language: "KOREAN" },
  { word: "사이", language: "KOREAN" },
  { word: "뒤로", language: "KOREAN" },
  { word: "너머", language: "KOREAN" },
  { word: "가지", language: "KOREAN" },
  { word: "오이", language: "KOREAN" },
  { word: "무", language: "KOREAN" },
  { word: "배추", language: "KOREAN" },
  { word: "고구마", language: "KOREAN" },
  { word: "수박", language: "KOREAN" },
  { word: "포도", language: "KOREAN" },
  { word: "자두", language: "KOREAN" },
  { word: "귤", language: "KOREAN" },
  { word: "감", language: "KOREAN" },
  { word: "콩", language: "KOREAN" },
  { word: "쌀", language: "KOREAN" },
  { word: "보리", language: "KOREAN" },
  { word: "밀", language: "KOREAN" },
  { word: "차", language: "KOREAN" },
  { word: "물", language: "KOREAN" },
  { word: "불", language: "KOREAN" },
  { word: "바람", language: "KOREAN" },
  { word: "비", language: "KOREAN" },
  { word: "눈", language: "KOREAN" },
  { word: "해", language: "KOREAN" },
  { word: "달", language: "KOREAN" },
  { word: "별", language: "KOREAN" },
  { word: "꽃", language: "KOREAN" },
  { word: "풀", language: "KOREAN" },
  { word: "산", language: "KOREAN" },
  { word: "강", language: "KOREAN" },
  { word: "숲", language: "KOREAN" },
  { word: "밭", language: "KOREAN" },
  { word: "길", language: "KOREAN" },
  { word: "집", language: "KOREAN" },
  { word: "방", language: "KOREAN" },
  { word: "문", language: "KOREAN" },
  { word: "창", language: "KOREAN" },
  { word: "벽", language: "KOREAN" },
  { word: "지붕", language: "KOREAN" },
  { word: "마루", language: "KOREAN" },
  { word: "하다", language: "KOREAN" },
  { word: "가다", language: "KOREAN" },
  { word: "오다", language: "KOREAN" },
  { word: "보다", language: "KOREAN" },
  { word: "주다", language: "KOREAN" },
  { word: "알다", language: "KOREAN" },
  { word: "살다", language: "KOREAN" },
  { word: "먹다", language: "KOREAN" },
  { word: "자다", language: "KOREAN" },
  { word: "서다", language: "KOREAN" },
  { word: "타다", language: "KOREAN" },
  { word: "쓰다", language: "KOREAN" },
  { word: "읽다", language: "KOREAN" },
  { word: "듣다", language: "KOREAN" },
  { word: "걷다", language: "KOREAN" },
  { word: "돌다", language: "KOREAN" },
  { word: "울다", language: "KOREAN" },
  { word: "웃다", language: "KOREAN" },
  { word: "앉다", language: "KOREAN" },
  { word: "눕다", language: "KOREAN" },
  { word: "열다", language: "KOREAN" },
  { word: "닫다", language: "KOREAN" },
  { word: "넣다", language: "KOREAN" },
  { word: "빼다", language: "KOREAN" },
  { word: "쏘다", language: "KOREAN" },
  { word: "차다", language: "KOREAN" },
  { word: "감다", language: "KOREAN" },
  { word: "씻다", language: "KOREAN" },
  { word: "입다", language: "KOREAN" },
  { word: "벗다", language: "KOREAN" },
  { word: "잡다", language: "KOREAN" },
  { word: "놓다", language: "KOREAN" },
  { word: "두다", language: "KOREAN" },
  { word: "찍다", language: "KOREAN" },
  { word: "짓다", language: "KOREAN" },
  { word: "심다", language: "KOREAN" },
  { word: "따다", language: "KOREAN" },
  { word: "캐다", language: "KOREAN" },
  { word: "팔다", language: "KOREAN" },
  { word: "사다", language: "KOREAN" },
  { word: "나오다", language: "KOREAN" },
  { word: "들다", language: "KOREAN" },
  { word: "내다", language: "KOREAN" },
  { word: "세다", language: "KOREAN" },
  { word: "크다", language: "KOREAN" },
  { word: "작다", language: "KOREAN" },
  { word: "높다", language: "KOREAN" },
  { word: "낮다", language: "KOREAN" },
  { word: "넓다", language: "KOREAN" },
  { word: "좁다", language: "KOREAN" },
  { word: "길다", language: "KOREAN" },
  { word: "짧다", language: "KOREAN" },
  { word: "빠르다", language: "KOREAN" },
  { word: "느리다", language: "KOREAN" },
  { word: "좋다", language: "KOREAN" },
  { word: "나쁘다", language: "KOREAN" },
  { word: "많다", language: "KOREAN" },
  { word: "적다", language: "KOREAN" },
  { word: "밝다", language: "KOREAN" },
  { word: "어둡다", language: "KOREAN" },
  { word: "덥다", language: "KOREAN" },
  { word: "춥다", language: "KOREAN" },
  { word: "맵다", language: "KOREAN" },
  { word: "달다", language: "KOREAN" },
  { word: "짜다", language: "KOREAN" },
  { word: "시다", language: "KOREAN" },
  { word: "우산", language: "KOREAN" },
  { word: "뜨다", language: "KOREAN" },
  { word: "연필", language: "KOREAN" },
  { word: "무겁다", language: "KOREAN" },
  { word: "가볍다", language: "KOREAN" },
  { word: "새", language: "KOREAN" },
  { word: "말", language: "KOREAN" },
  { word: "소", language: "KOREAN" },
  { word: "개", language: "KOREAN" },
  { word: "닭", language: "KOREAN" },
  { word: "돼지", language: "KOREAN" },
  { word: "양", language: "KOREAN" },
  { word: "곰", language: "KOREAN" },
  { word: "쥐", language: "KOREAN" },
  { word: "피아노", language: "KOREAN" },
  { word: "기타", language: "KOREAN" },
  { word: "북", language: "KOREAN" },
  { word: "종", language: "KOREAN" },
  { word: "책", language: "KOREAN" },
  { word: "펜", language: "KOREAN" },
  { word: "칼", language: "KOREAN" },
  { word: "밥", language: "KOREAN" },
  { word: "국", language: "KOREAN" },
  { word: "떡", language: "KOREAN" },
  { word: "김", language: "KOREAN" },
  { word: "빵", language: "KOREAN" },
  { word: "과자", language: "KOREAN" },
  { word: "사탕", language: "KOREAN" },
  { word: "라면", language: "KOREAN" },
  { word: "김치", language: "KOREAN" },
  { word: "된장", language: "KOREAN" },
  { word: "간장", language: "KOREAN" },
  { word: "식초", language: "KOREAN" },
  { word: "설탕", language: "KOREAN" },
  // === NORMAL ===
  { word: "컴퓨터", language: "KOREAN" },
  { word: "인터넷", language: "KOREAN" },
  { word: "전화기", language: "KOREAN" },
  { word: "냉장고", language: "KOREAN" },
  { word: "텔레비전", language: "KOREAN" },
  { word: "에어컨", language: "KOREAN" },
  { word: "세탁기", language: "KOREAN" },
  { word: "청소기", language: "KOREAN" },
  { word: "전자레인지", language: "KOREAN" },
  { word: "건조기", language: "KOREAN" },
  { word: "학교", language: "KOREAN" },
  { word: "병원", language: "KOREAN" },
  { word: "도서관", language: "KOREAN" },
  { word: "공항", language: "KOREAN" },
  { word: "경찰서", language: "KOREAN" },
  { word: "소방서", language: "KOREAN" },
  { word: "우체국", language: "KOREAN" },
  { word: "은행", language: "KOREAN" },
  { word: "약국", language: "KOREAN" },
  { word: "백화점", language: "KOREAN" },
  { word: "편의점", language: "KOREAN" },
  { word: "식당", language: "KOREAN" },
  { word: "커피숍", language: "KOREAN" },
  { word: "빵집", language: "KOREAN" },
  { word: "서점", language: "KOREAN" },
  { word: "미용실", language: "KOREAN" },
  { word: "꽃집", language: "KOREAN" },
  { word: "정육점", language: "KOREAN" },
  { word: "문구점", language: "KOREAN" },
  { word: "안경점", language: "KOREAN" },
  { word: "축구", language: "KOREAN" },
  { word: "야구", language: "KOREAN" },
  { word: "농구", language: "KOREAN" },
  { word: "배구", language: "KOREAN" },
  { word: "탁구", language: "KOREAN" },
  { word: "수영", language: "KOREAN" },
  { word: "달리기", language: "KOREAN" },
  { word: "줄넘기", language: "KOREAN" },
  { word: "자전거", language: "KOREAN" },
  { word: "등산", language: "KOREAN" },
  { word: "음악", language: "KOREAN" },
  { word: "미술", language: "KOREAN" },
  { word: "영화", language: "KOREAN" },
  { word: "연극", language: "KOREAN" },
  { word: "무용", language: "KOREAN" },
  { word: "사진", language: "KOREAN" },
  { word: "독서", language: "KOREAN" },
  { word: "요리", language: "KOREAN" },
  { word: "낚시", language: "KOREAN" },
  { word: "여행", language: "KOREAN" },
  { word: "건축", language: "KOREAN" },
  { word: "설계", language: "KOREAN" },
  { word: "공사", language: "KOREAN" },
  { word: "장비", language: "KOREAN" },
  { word: "기술", language: "KOREAN" },
  { word: "과학", language: "KOREAN" },
  { word: "수학", language: "KOREAN" },
  { word: "역사", language: "KOREAN" },
  { word: "지리", language: "KOREAN" },
  { word: "경제", language: "KOREAN" },
  { word: "정치", language: "KOREAN" },
  { word: "사회", language: "KOREAN" },
  { word: "문화", language: "KOREAN" },
  { word: "예술", language: "KOREAN" },
  { word: "교육", language: "KOREAN" },
  { word: "의료", language: "KOREAN" },
  { word: "법률", language: "KOREAN" },
  { word: "환경", language: "KOREAN" },
  { word: "통신", language: "KOREAN" },
  { word: "교통", language: "KOREAN" },
  { word: "항공", language: "KOREAN" },
  { word: "철도", language: "KOREAN" },
  { word: "선박", language: "KOREAN" },
  { word: "우주", language: "KOREAN" },
  { word: "화학", language: "KOREAN" },
  { word: "물리", language: "KOREAN" },
  { word: "생물", language: "KOREAN" },
  { word: "천문", language: "KOREAN" },
  { word: "기상", language: "KOREAN" },
  { word: "지질", language: "KOREAN" },
  { word: "농업", language: "KOREAN" },
  { word: "어업", language: "KOREAN" },
  { word: "임업", language: "KOREAN" },
  { word: "축산", language: "KOREAN" },
  { word: "광업", language: "KOREAN" },
  { word: "제조", language: "KOREAN" },
  { word: "유통", language: "KOREAN" },
  { word: "물류", language: "KOREAN" },
  { word: "관광", language: "KOREAN" },
  { word: "금융", language: "KOREAN" },
  { word: "보험", language: "KOREAN" },
  { word: "증권", language: "KOREAN" },
  { word: "부동산", language: "KOREAN" },
  { word: "무역", language: "KOREAN" },
  { word: "외교", language: "KOREAN" },
  { word: "국방", language: "KOREAN" },
  { word: "복지", language: "KOREAN" },
  { word: "체육", language: "KOREAN" },
  { word: "언론", language: "KOREAN" },
  { word: "출판", language: "KOREAN" },
  { word: "방송", language: "KOREAN" },
  { word: "광고", language: "KOREAN" },
  { word: "디자인", language: "KOREAN" },
  { word: "패션", language: "KOREAN" },
  { word: "건강", language: "KOREAN" },
  { word: "영양", language: "KOREAN" },
  { word: "운동", language: "KOREAN" },
  { word: "치료", language: "KOREAN" },
  { word: "수술", language: "KOREAN" },
  { word: "약품", language: "KOREAN" },
  { word: "민주주의", language: "KOREAN" },
  { word: "자유", language: "KOREAN" },
  { word: "평등", language: "KOREAN" },
  { word: "정의", language: "KOREAN" },
  { word: "인권", language: "KOREAN" },
  { word: "환경보호", language: "KOREAN" },
  { word: "재활용", language: "KOREAN" },
  { word: "절약", language: "KOREAN" },
  { word: "봉사", language: "KOREAN" },
  { word: "협력", language: "KOREAN" },
  { word: "만들다", language: "KOREAN" },
  { word: "고치다", language: "KOREAN" },
  { word: "바꾸다", language: "KOREAN" },
  { word: "옮기다", language: "KOREAN" },
  { word: "모으다", language: "KOREAN" },
  { word: "나누다", language: "KOREAN" },
  { word: "섞다", language: "KOREAN" },
  { word: "붓다", language: "KOREAN" },
  { word: "깎다", language: "KOREAN" },
  { word: "자르다", language: "KOREAN" },
  { word: "꿰매다", language: "KOREAN" },
  { word: "감싸다", language: "KOREAN" },
  { word: "펼치다", language: "KOREAN" },
  { word: "접다", language: "KOREAN" },
  { word: "매달다", language: "KOREAN" },
  { word: "쌓다", language: "KOREAN" },
  { word: "채우다", language: "KOREAN" },
  { word: "비우다", language: "KOREAN" },
  { word: "덮다", language: "KOREAN" },
  { word: "벗기다", language: "KOREAN" },
  { word: "끓이다", language: "KOREAN" },
  { word: "볶다", language: "KOREAN" },
  { word: "굽다", language: "KOREAN" },
  { word: "찌다", language: "KOREAN" },
  { word: "삶다", language: "KOREAN" },
  { word: "데치다", language: "KOREAN" },
  { word: "튀기다", language: "KOREAN" },
  { word: "말리다", language: "KOREAN" },
  { word: "절이다", language: "KOREAN" },
  { word: "무치다", language: "KOREAN" },
  { word: "달리다", language: "KOREAN" },
  { word: "뛰다", language: "KOREAN" },
  { word: "걸어가다", language: "KOREAN" },
  { word: "올라가다", language: "KOREAN" },
  { word: "내려가다", language: "KOREAN" },
  { word: "건너다", language: "KOREAN" },
  { word: "돌아가다", language: "KOREAN" },
  { word: "따라가다", language: "KOREAN" },
  { word: "지나가다", language: "KOREAN" },
  { word: "다가가다", language: "KOREAN" },
  { word: "기다리다", language: "KOREAN" },
  { word: "바라보다", language: "KOREAN" },
  { word: "돌아보다", language: "KOREAN" },
  { word: "살펴보다", language: "KOREAN" },
  { word: "찾아보다", language: "KOREAN" },
  { word: "알아보다", language: "KOREAN" },
  { word: "생각하다", language: "KOREAN" },
  { word: "느끼다", language: "KOREAN" },
  { word: "믿다", language: "KOREAN" },
  { word: "의심하다", language: "KOREAN" },
  { word: "약속하다", language: "KOREAN" },
  { word: "계획하다", language: "KOREAN" },
  { word: "준비하다", language: "KOREAN" },
  { word: "시작하다", language: "KOREAN" },
  { word: "마치다", language: "KOREAN" },
  { word: "끝내다", language: "KOREAN" },
  { word: "이루다", language: "KOREAN" },
  { word: "성공하다", language: "KOREAN" },
  { word: "실패하다", language: "KOREAN" },
  { word: "노력하다", language: "KOREAN" },
  { word: "배우다", language: "KOREAN" },
  { word: "가르치다", language: "KOREAN" },
  { word: "연습하다", language: "KOREAN" },
  { word: "훈련하다", language: "KOREAN" },
  { word: "시험보다", language: "KOREAN" },
  { word: "졸업하다", language: "KOREAN" },
  { word: "입학하다", language: "KOREAN" },
  { word: "공부하다", language: "KOREAN" },
  { word: "복습하다", language: "KOREAN" },
  { word: "예습하다", language: "KOREAN" },
  { word: "일하다", language: "KOREAN" },
  { word: "쉬다", language: "KOREAN" },
  { word: "놀다", language: "KOREAN" },
  { word: "즐기다", language: "KOREAN" },
  { word: "구경하다", language: "KOREAN" },
  { word: "참여하다", language: "KOREAN" },
  { word: "도와주다", language: "KOREAN" },
  { word: "부탁하다", language: "KOREAN" },
  { word: "거절하다", language: "KOREAN" },
  { word: "동의하다", language: "KOREAN" },
  // === HARD ===
  { word: "칠면조", language: "KOREAN" },
  { word: "청경채", language: "KOREAN" },
  { word: "뜨개질", language: "KOREAN" },
  { word: "짜장면", language: "KOREAN" },
  { word: "찜닭", language: "KOREAN" },
  { word: "떡볶이", language: "KOREAN" },
  { word: "쪽파", language: "KOREAN" },
  { word: "쑥갓", language: "KOREAN" },
  { word: "깻잎", language: "KOREAN" },
  { word: "씀바귀", language: "KOREAN" },
  { word: "뒤뚱뒤뚱", language: "KOREAN" },
  { word: "아장아장", language: "KOREAN" },
  { word: "빙글빙글", language: "KOREAN" },
  { word: "울퉁불퉁", language: "KOREAN" },
  { word: "오르락내리락", language: "KOREAN" },
  { word: "허둥지둥", language: "KOREAN" },
  { word: "끄덕끄덕", language: "KOREAN" },
  { word: "두근두근", language: "KOREAN" },
  { word: "반짝반짝", language: "KOREAN" },
  { word: "살금살금", language: "KOREAN" },
  { word: "흩뿌리다", language: "KOREAN" },
  { word: "뒤엎다", language: "KOREAN" },
  { word: "껴안다", language: "KOREAN" },
  { word: "쪼개다", language: "KOREAN" },
  { word: "끌어당기다", language: "KOREAN" },
  { word: "뛰어넘다", language: "KOREAN" },
  { word: "짓밟다", language: "KOREAN" },
  { word: "움켜쥐다", language: "KOREAN" },
  { word: "휘감다", language: "KOREAN" },
  { word: "엎드리다", language: "KOREAN" },
  { word: "띄어쓰기", language: "KOREAN" },
  { word: "꼬불꼬불", language: "KOREAN" },
  { word: "쭈뼛쭈뼛", language: "KOREAN" },
  { word: "쩔쩔매다", language: "KOREAN" },
  { word: "삐죽삐죽", language: "KOREAN" },
  { word: "꾸물꾸물", language: "KOREAN" },
  { word: "뾰족하다", language: "KOREAN" },
  { word: "쫄깃쫄깃", language: "KOREAN" },
  { word: "찌릿찌릿", language: "KOREAN" },
  { word: "끈적끈적", language: "KOREAN" },
  { word: "뛰쳐나가다", language: "KOREAN" },
  { word: "뒤집어쓰다", language: "KOREAN" },
  { word: "끌어안다", language: "KOREAN" },
  { word: "쫓아다니다", language: "KOREAN" },
  { word: "움츠리다", language: "KOREAN" },
  { word: "쪼그리다", language: "KOREAN" },
  { word: "빼앗기다", language: "KOREAN" },
  { word: "뒤돌아보다", language: "KOREAN" },
  { word: "떠들썩하다", language: "KOREAN" },
  { word: "꿈틀거리다", language: "KOREAN" },
  { word: "짓궂다", language: "KOREAN" },
  { word: "쏟아지다", language: "KOREAN" },
  { word: "뿌리치다", language: "KOREAN" },
  { word: "찡그리다", language: "KOREAN" },
  { word: "써먹다", language: "KOREAN" },
  { word: "떨어뜨리다", language: "KOREAN" },
  { word: "끼어들다", language: "KOREAN" },
  { word: "찌그러뜨리다", language: "KOREAN" },
  { word: "헝클어뜨리다", language: "KOREAN" },
  { word: "뒤죽박죽", language: "KOREAN" },
  { word: "엉망진창", language: "KOREAN" },
  { word: "좌충우돌", language: "KOREAN" },
  { word: "우왕좌왕", language: "KOREAN" },
  { word: "갈팡질팡", language: "KOREAN" },
  { word: "허겁지겁", language: "KOREAN" },
  { word: "벌러덩", language: "KOREAN" },
  { word: "꼬지꼬지", language: "KOREAN" },
  { word: "뜬금없다", language: "KOREAN" },
  { word: "어처구니없다", language: "KOREAN" },
  { word: "찰나", language: "KOREAN" },
  { word: "앙큼하다", language: "KOREAN" },
  { word: "깐깐하다", language: "KOREAN" },
  { word: "삐뚤어지다", language: "KOREAN" },
  { word: "뒤틀리다", language: "KOREAN" },
  { word: "짓이기다", language: "KOREAN" },
  { word: "꿰뚫다", language: "KOREAN" },
  { word: "냅다", language: "KOREAN" },
  { word: "내쫓다", language: "KOREAN" },
  { word: "뜯어고치다", language: "KOREAN" },
  { word: "부숴뜨리다", language: "KOREAN" },
  { word: "쓸쓸하다", language: "KOREAN" },
  { word: "꺼림칙하다", language: "KOREAN" },
  { word: "얄밉다", language: "KOREAN" },
  { word: "섬뜩하다", language: "KOREAN" },
  { word: "째깍째깍", language: "KOREAN" },
  { word: "쿵쾅쿵쾅", language: "KOREAN" },
  { word: "촐랑촐랑", language: "KOREAN" },
  { word: "뒤뜰", language: "KOREAN" },
  { word: "쪽빛", language: "KOREAN" },
  { word: "뾰루지", language: "KOREAN" },
  { word: "뻣뻣하다", language: "KOREAN" },
  { word: "꼬치꼬치", language: "KOREAN" },
  { word: "징그럽다", language: "KOREAN" },
  { word: "엉뚱하다", language: "KOREAN" },
  { word: "괜찮다", language: "KOREAN" },
  { word: "뚝딱뚝딱", language: "KOREAN" },
  { word: "뿔뿔이", language: "KOREAN" },
  { word: "뒤범벅", language: "KOREAN" },
  { word: "쓰러뜨리다", language: "KOREAN" },
  { word: "떠받들다", language: "KOREAN" },
  { word: "울컥하다", language: "KOREAN" },
  { word: "철렁하다", language: "KOREAN" },
  { word: "찔끔찔끔", language: "KOREAN" },
  { word: "삐걱삐걱", language: "KOREAN" },
  { word: "뚝뚝", language: "KOREAN" },
  { word: "끙끙", language: "KOREAN" },
  { word: "꽁꽁", language: "KOREAN" },
  { word: "휑하다", language: "KOREAN" },
  { word: "짬뽕", language: "KOREAN" },
  { word: "씽씽", language: "KOREAN" },
  { word: "째려보다", language: "KOREAN" },
  { word: "꼬장부리다", language: "KOREAN" },
  { word: "텁텁하다", language: "KOREAN" },
  { word: "어리둥절하다", language: "KOREAN" },
  { word: "끝내주다", language: "KOREAN" },
  { word: "뻔뻔하다", language: "KOREAN" },
  { word: "어이없다", language: "KOREAN" },
  { word: "깜짝놀라다", language: "KOREAN" },
  { word: "뒤숭숭하다", language: "KOREAN" },
  { word: "촘촘하다", language: "KOREAN" },
  { word: "쥐어짜다", language: "KOREAN" },
  { word: "뒤흔들다", language: "KOREAN" },
  { word: "내뱉다", language: "KOREAN" },
  { word: "짓누르다", language: "KOREAN" },
  { word: "찢어발기다", language: "KOREAN" },
  { word: "뜯어먹다", language: "KOREAN" },
  { word: "끌어내리다", language: "KOREAN" },
  { word: "쏟아붓다", language: "KOREAN" },
  { word: "내리꽂다", language: "KOREAN" },
  { word: "짓뭉개다", language: "KOREAN" },
  { word: "비틀거리다", language: "KOREAN" },
  { word: "허우적거리다", language: "KOREAN" },
  { word: "더듬거리다", language: "KOREAN" },
  { word: "중얼거리다", language: "KOREAN" },
  { word: "투덜거리다", language: "KOREAN" },
  { word: "우물쭈물하다", language: "KOREAN" },
  { word: "뒤척거리다", language: "KOREAN" },
  { word: "전전긍긍하다", language: "KOREAN" },
  { word: "안달복달하다", language: "KOREAN" },
  { word: "아등바등하다", language: "KOREAN" },
  { word: "후련하다", language: "KOREAN" },
  { word: "찜찜하다", language: "KOREAN" },
  { word: "뻘쭘하다", language: "KOREAN" },
  { word: "어수선하다", language: "KOREAN" },
  { word: "깜깜하다", language: "KOREAN" },
  { word: "헐렁하다", language: "KOREAN" },
  { word: "빽빽하다", language: "KOREAN" },
  { word: "찡하다", language: "KOREAN" },
  { word: "뿌듯하다", language: "KOREAN" },
  { word: "씁쓸하다", language: "KOREAN" },
  { word: "짜증나다", language: "KOREAN" },
  { word: "뒷북치다", language: "KOREAN" },
  { word: "깔보다", language: "KOREAN" },
  { word: "얕보다", language: "KOREAN" },
  { word: "업신여기다", language: "KOREAN" },
  { word: "들이받다", language: "KOREAN" },
  { word: "쫓겨나다", language: "KOREAN" },
  { word: "내동댕이치다", language: "KOREAN" },
  { word: "뻗대다", language: "KOREAN" },
  { word: "옥신각신하다", language: "KOREAN" },
  { word: "구시렁거리다", language: "KOREAN" },
  { word: "꼬투리잡다", language: "KOREAN" },
  { word: "트집잡다", language: "KOREAN" },
  { word: "꼼꼼하다", language: "KOREAN" },
  { word: "뜯어말리다", language: "KOREAN" },
  { word: "끌어모으다", language: "KOREAN" },
  { word: "쓸어담다", language: "KOREAN" },
  { word: "떨쳐내다", language: "KOREAN" },
  { word: "뿌리뽑다", language: "KOREAN" },
  { word: "갈아엎다", language: "KOREAN" },
  { word: "오글거리다", language: "KOREAN" },
  { word: "쭈글쭈글하다", language: "KOREAN" },
  { word: "꼬깃꼬깃하다", language: "KOREAN" },
  { word: "울긋불긋하다", language: "KOREAN" },
  { word: "알록달록하다", language: "KOREAN" },
  { word: "얼룩덜룩하다", language: "KOREAN" },
  { word: "오돌토돌하다", language: "KOREAN" },
  { word: "꾸불꾸불하다", language: "KOREAN" },
  { word: "구불구불하다", language: "KOREAN" },
  { word: "삐뚤빼뚤하다", language: "KOREAN" },
];
